import angular from 'angular';
import directive from './numbers-only.directive.js';

const numbersOnly = angular
    .module('FacilityData.Common.NumbersOnly', [])
    .directive('numbersOnly', directive)
    .name;

export default numbersOnly;


// WEBPACK FOOTER //
// ./app/common/directives/numbers-only.js